import React, { FC, useMemo, useRef } from 'react';
import { TableRow, TableCell, TextField, makeStyles, Grid } from '@material-ui/core';
import NumberFormatMask from 'components/NumberFormatMask';
import NumberFormat from 'components/NumberFormat';
import { InfoOutlined } from '@material-ui/icons';
import { YELLOW_MOBILE } from 'constants/colors';
import { PURCHASE_INVOICE_ITEM_URL } from 'constants/url';
import axios from 'axios';

interface Props {
  item: PurchaseInvoiceItemModel;
  handleSetValue: (value: PurchaseInvoiceItemModel) => void;
  handleOpenHistory: () => void;
  setProductId: (value: number) => void;
  historyResource: { price: number; discount: number; totalItem: number; discountUnit?: number; orderDate: string }[];
}

const useStyles = makeStyles({
  cellProduct: { width: '25%' },
  cellQty: { width: '13%' }
});

const PurchaseInvoiceItem: FC<Props> = props => {
  const classes = useStyles();

  const { handleOpenHistory, setProductId, item, handleSetValue, historyResource } = props;

  const originalPriceRef = useRef<number>(item.price);

  const maxAllowedFromHistory = useMemo(() => {
    if (!historyResource || historyResource.length === 0) return undefined;
    const latest = historyResource[0];
    const unitDiscount = latest.discountUnit ?? (latest.discount ?? 0) / (latest.totalItem && latest.totalItem > 0 ? latest.totalItem : 1);
    const netUnitPrice = latest.price - unitDiscount;
    return netUnitPrice;
  }, [historyResource]);

  const priceErrorMessage = useMemo(() => {
    if (item.price === 0) return 'Harga tidak boleh kosong';
    return '';
  }, [item.price]);

  return (
    <TableRow>
      <TableCell className={classes.cellProduct}>{(item.Product && item.Product.productName) || ''}</TableCell>

      <TableCell>
        <Grid container alignItems='center' wrap='nowrap'>
          <Grid item xs>
            <TextField
              variant='standard'
              size='small'
              required
              fullWidth
              label='Harga'
              value={item.price > 0 ? item.price : null}
              onChange={event => handleSetValue({ ...item, price: +event.target.value })}
              InputProps={{
                inputComponent: NumberFormatMask as any
              }}
              error={priceErrorMessage !== ''}
              helperText={priceErrorMessage}
            />
          </Grid>
          <Grid item>
            <InfoOutlined
              style={{ color: YELLOW_MOBILE, cursor: 'pointer', marginLeft: 8 }}
              onClick={() => {
                setProductId(item.ProductId);
                handleOpenHistory();
              }}
            />
          </Grid>
        </Grid>
      </TableCell>

      <TableCell className={classes.cellQty}>{`${item.totalItem} ${item.typeUnit}`}</TableCell>

      <TableCell align='right'>
        <TextField
          fullWidth
          variant='standard'
          size='small'
          label='Diskon'
          value={item.discount > 0 ? item.discount : null}
          onChange={event => handleSetValue({ ...item, discount: +event.target.value })}
          InputProps={{
            inputComponent: NumberFormatMask as any
          }}
        />
      </TableCell>

      <TableCell>
        <NumberFormat value={item.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
      </TableCell>

      <TableCell>
        <NumberFormat value={item.unitNetPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
      </TableCell>
    </TableRow>
  );
};

export default PurchaseInvoiceItem;
